import lodash from 'lodash'

const getDefaultState = () => {
    return {
        customFilters: null as null | Record<string, any>,
        meMode: false,
        contractorHierarchies: {},
        observationTemplate: [],
        observation: {},
        attachment: {},
        category: [],
        cause: [],
        project: {},
        projectSettings: {},
        user: {},
        company: {},
        groupResource: {},
    }
}

const state = getDefaultState()

const getters = {
    customFilters(state: any) {
        return state.customFilters
    },

    meMode(state: any) {
        return state.meMode
    },

    contractorHierarchies(state: any) {
        return state.contractorHierarchies
    },

    contractorHierarchiesByProject: (state: any) => (projectId: string) => {
        return state.contractorHierarchies[projectId]
    },

    // OBSERVSTION TEMPLATES
    observationTemplates(state: any) {
        return state.observationTemplate
    },

    observationTemplate: (state: any) => (id: string) => {
        return state.observationTemplate.find((val) => val.id == id)
    },

    // OBSERVSTIONS
    observations(state: any) {
        return state.observation
    },

    observation: (state: any) => (id: string) => {
        return state.observation[id]
    },

    // ATTACHMENTS
    observationAttachments(state: any) {
        return state.attachment
    },

    observationAttachment: (state: any) => (id: string) => {
        return state.attachment[id]
    },

    // CATEGORY
    observationCategories(state: any) {
        return state.category
    },

    observationCategory: (state: any) => (id: string) => {
        return state.category.find((item) => item.id == id)
    },

    // CAUSE
    observationCauses(state: any) {
        return state.cause
    },

    observationCause: (state: any) => (id: string) => {
        return state.cause.find((item) => item.id == id)
    },

    // PROJECT
    observationProjects(state: any) {
        return state.project
    },

    observationProject: (state: any) => (id: string) => {
        return state.project[id]
    },

    // PROJECT SETTINGS
    observationProjectSettings(state: any) {
        return state.projectSettings
    },

    observationProjectSetting: (state: any) => (id: string) => {
        return state.projectSettings[id]
    },

    // USER
    observationUsers(state: any) {
        return state.user
    },

    observationUser: (state: any) => (id: string) => {
        return state.user[id]
    },

    // COMPANY
    observationCompanies(state: any) {
        return state.company
    },

    observationCompany: (state: any) => (id: string) => {
        return state.company[id]
    },

    // Group resources
    observationGroupResources(state: any) {
        return state.groupResource
    },

    observationGroupResource: (state: any) => (id: string) => {
        return state.groupResource[id]
    },
}

const mutations = {
    customFilters(state: any, payload: null | Record<string, any>) {
        state.customFilters = payload
    },

    meMode(state: any, payload: boolean) {
        state.meMode = payload
    },

    contractorHierarchies(state: any, payload: null | Record<string, any>) {
        state.contractorHierarchies = payload
    },

    contractorHierarchy(state: any, payload: { id: string; data: Record<string, any> }) {
        const contractorHierarchies = lodash.cloneDeep(state.contractorHierarchies)
        contractorHierarchies[payload.id] = payload.data
        state.contractorHierarchies = contractorHierarchies
    },
    // OBSERVSTION TEMPLATE
    observationTemplates(state: any, payload: any) {
        state.observationTemplate = payload
    },

    // OBSERVSTIONS
    observations(state: any, payload: any) {
        state.observation = payload
    },

    // ATTACHMENTS
    observationAttachments(state: any, payload: any) {
        state.attachment = payload
    },

    // CATEGORY
    observationCategories(state: any, payload: any) {
        state.category = payload
    },

    // CAUSE
    observationCauses(state: any, payload: any) {
        state.cause = payload
    },

    // PROJECT
    observationProjects(state: any, payload: any) {
        state.project = payload
    },

    // PROJECT SETTINGS
    observationProjectSettings(state: any, payload: any) {
        state.projectSettings = payload
    },

    // USER
    observationUsers(state: any, payload: any) {
        state.user = payload
    },

    // COMPANY
    observationCompanies(state: any, payload: any) {
        state.company = payload
    },

    // Group resources
    observationGroupResources(state: any, payload: any) {
        state.groupResource = payload
    },

    //RESET
    resetObservation(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
